import ociUtils from '@/common/resources/ociUtils.js'

/**
 * Shortened wrapper function
 * @deprecated to be replaced by a similarly named function, but directly imported from ociUtils, rather than wrapping
 * @param args - items to log
 */
function ociLog(...args){
  ociUtils.global.ociEnvLog(...args);
}

export default {
  getActivityEvents: state => {
    return state.activityEvents;
  },
  getOciAnalytics: state => {
    return state.ociAnalytics;
  },
  getProjectUploadColumns: state => {
    return state.projectUploadColumns;
  },
  getLenderAnalytics: state => {

    return state.lenderAnalytics;
  },
  getLenderPage: state => {
    return state.lenderPage;
  },
  getLenderData: state => {
    return state.lenderClientDataData;
  },
  mostRecentCampaignsStatus: state => {
    return state.mostRecentCampaignsStatus;
  },
  fileScanning: state => {
    return state.fileScanning;
  },
  purchaserDetails: state => {
    return state.purchaserDetails;
  },
  getLenderCriteriaResultsByLender: state => {
    return state.lenderCriteriaResults;
  },
  getEventsByLoanId: state => {
    return state.eventsByLoanId;
  },
  getProjectCodes: state => {
    return state.projectCodes;
  },
  persons: state => {
    return state.persons
  },
  count: state => {
    return state.count
  },
  applicants: state => {
    return state.applicants
  },
  selectedApplicants: state => {
    return state.selectedApplicants
  },
  clientsData: state => {
    return state.clientsData
  },
  firms: state => {
    return state.firms
  },
  firmsByType: state => {
    return state.firmsByType
  },
  projectsByFirm: state => {
    return state.projectsByFirm
  },
  projects: state => {
    return state.projects
  },
  firm: state => {
    return state.firm
  },
  firmRep: state => {
    return state.firmRep
  },
  firmRepsWithUserInfo: state => {
    return state.firmRepsWithUserInfo
  },
  person: state => {
    return state.person
  },
  enrollmentPhase: state => {
    return state.enrollmentPhase
  },
  dataLoading: state => {
    return state.dataLoading
  },
  messages: state => {
    return state.messages
  },
  type: state => {
    return state.type
  },
  project: state => {
    return state.project
  },
  activeClient: state => {
    return state.activeClient
  },
  activeMessage: state => {
    return state.activeMessage
  },
  purchasePrice: state => {
    return state.purchasePrice
  },
  activeSpouse: state => {
    return state.activeSpouse
  },
  activeFirm: state => {
    return state.activeFirm
  },
  applicant: state => {
    return state.applicant
  },
  spouse: state => {
    return state.spouse
  },
  activeApplicant: state => {
    return state.activeApplicant
  },
  projectAssetPurchasePrice: state => {
    return state.projectAssetPurchasePrice
  },
  coApplicant: state => {
    return state.coApplicant
  },
  activeCoApplicant: state => {
    return state.activeCoApplicant
  },

  msgTypeArray: state => {
    return state.msgTypeArray
  },
  edsFunding: state => {
    return state.edsFunding;
  },
  filterInactiveMessages: state => {
    return state.messages.filter(message => message.active === false)
  },
  filterActiveMessages: state => {
    return state.messages.filter(message => message.active === true)
  },
  applicantByProfile: state => {
    return state.applicantByProfile
  },
//Auth and Session

  authResponse: state=>{
    return state.authResponse;
  },
  appUser: state => {
    return state.appUser
  },
  userRoles: state => {
    if (state.appUser.roles.length > 0) {
      return state.appUser.roles
    }
  },
  authStatus: state => {
    return state.userStatus
  },
  userHome: state => {
    return state.userHome
  },
  authPermissions: state => {
    return state.authPermissions
  },
  tokenPresent: state => {
    if (sessionStorage.getItem('ocu') == null) {
      return false
    } else {
      return true
    }
  },
  userToken: state => {
    return state.userToken
  },
  projectAsset: state => {
    return state.projectAsset
  },
  coApplicantArray: state => {
    return state.coApplicantArray
  },
  projectAssetByApplicant: state => {
    return state.projectAssetByApplicant
  },
  purchasePriceSum: state => {
    return state.purchasePriceSum
  },
  purchasePriceSumAwareness: state => {
    return state.purchasePriceSumAwareness
  },
  purchasePriceSumExploration: state => {
    return state.purchasePriceSumExploration
  },
  purchasePriceSumApproval: state => {
    return state.purchasePriceSumApproval
  },
  fileUploaded: state => {
    return state.fileUploaded
  },
  documents: state => {
    return state.documents
  },
  sessionInfo: state => {
    return state.sessionInfo
  },
  filterConsiderationType: state => {
    return selectConsiderationType => state.activeApplicationApplicant.loanApplication.projectAssets.find(asset => asset.considerationType === selectConsiderationType)
  },
  activeApplicationApplicant: state => {
    return state.activeApplicationApplicant
  },
  applicationHistoryDetails: state => {
    return state.applicationHistoryDetails
  },
  applicationStatus: state => {
    return state.applicationStatus
  },

  allAvailableGroups: state =>{
    let roleGroups = [];
    for (let i=0; i<state.availableGroupRoles.length;i++)  {

      let groupExist= false;
      for (let j=0; j<roleGroups.length;j++)  {
      if(state.availableGroupRoles[i].group === roleGroups[j].group){
        groupExist=true;
        break;
       }
      }
      if(groupExist===false && state.availableGroupRoles[i].group!=='user' && state.availableGroupRoles[i].group!=='super'){
        roleGroups.push(state.availableGroupRoles[i])
      }
    }
    return roleGroups
  },
availableGroupRoles: state =>{
        return state.availableGroupRoles
},
  filteredGroupRoles: state => {
    return selectedGroup =>state.availableGroupRoles.filter(role =>
     role.group!=='user' && role.group === selectedGroup)
  },
  // getters ref to chats

  purchaserChat: state => {
    return state.purchaserChat
  },

  purchaserChats: state => {
    return state.purchaserChats
  },
  purchaserChatMessages: state => {
    return state.purchaserChatMessages
  },
  userChats: state => {
    return state.userChats
  },
  currentChatMessages: state => {
    return state.currentChatMessages
  },
  currentNotifications: state => {
    return state.currentNotifications
  },
  //filtered current Notifications with those which match user permisions

  subscribedNotifications: state => {

    let notifications = state.currentNotifications;
    let filtered = [];
    for (let i = 0; i < notifications.length; i++) {
      let match = false;
      //check if  subscribed roles matches any user role
      for (let j = 0; j < state.appUser.roles.length; j++) {
        for (let k = 0; k < notifications[i].subscribedRoles.length; k++) {
          if (notifications[i].subscribedRoles[k] === state.appUser.roles[j].role) {
            match = true;
          }
        }
      }
      //TODO - to complete this after appUser has added detail of firm profile if they are part of a firm.
      //check if firm matches
      if (notifications[i].subscribedFirms.includes(state.appUser.firmProfileId)) {
        match = true;
      }
      //check if subscribed profile ids matches user profileId
      if (notifications[i].subscribedPersons.includes(state.appUser.profileId)) {
        match = true;
      }
      if (match) {
        filtered.push(notifications[i])
      }


    }
    return filtered;

  },

  subscribedNotificationsNotDisplayed: state => {

    let notifications = state.currentNotifications;
    let filtered = [];
    for (let i = 0; i < notifications.length; i++) {
      let match = false;
      //check if  subscribed roles matches any user role
      for (let j = 0; j < state.appUser.roles.length; j++) {
        for (let k = 0; k < notifications[i].subscribedRoles.length; k++) {
          if (notifications[i].subscribedRoles[k] === state.appUser.roles[j].role) {
            match = true;
          }
        }
      }
      //TODO - to complete this after appUser has added detail of firm profile if they are part of a firm.
      //check if firm matches
      if (notifications[i].subscribedFirms.includes(1)) {
        match = true;
      }
      //check if subscribed profile ids matches user profileId
      if (notifications[i].subscribedPersons.includes(state.appUser.profileId)) {
        match = true;
      }
      if (match) {
        let displayed = false;
        //TODO additional step to compare with localStorgage, viewed
        if (localStorage.getItem("notifications-displayed") !== null) {
          let displayedNotificationsArray = JSON.parse(localStorage.getItem("notifications-displayed"));

          for (let a = 0; a < displayedNotificationsArray.length; a++) {
            if (notifications[i].messageId === displayedNotificationsArray[a].messageId) {
              displayed = true;
            }
          }

        }
        if (displayed === false) {
          filtered.push(notifications[i])
        }

      }


    }
    return filtered;
  },
  //TODO - Complete logic for accessible notifications which user can edit
  accessibleNotifications: state => {
    let match = false;
    let notifications = state.currentNotifications;
    for (let i = 0; i < notifications.length; i++) {

    }

  },
  notificationHistoryDisplay: state => {
    return state.notificationHistoryDisplay
  },

  getAssetValue: state => {
    return state.assetValue
  },
  getCoApplicantAssets: state => {
    return state.coApplicantAssets
  },
  getLiabilitiesValue: state => {
    return state.liabilitiesValue
  },
  getOtherLiabilities: state => {
    return state.otherLiabilities
  },

  getError: state => {
    return state.error
  },
  brokerChatPageOpen: state => {
    return state.brokerChatPageOpen
  },
  brokerMiniChatOpen: state => {
    return state.brokerMiniChatOpen
  },
  getOccupancyType: state => {
    return state.occupancyType
  },
  getMonthlyRent: state => {
    return state.monthlyRent
  },
  getRecentApplications: state => {
    return state.recentApplications
  },
  // Editable Copies
  allApplicationApplicants: state => {
    return state.allApplicationApplicants
  },
  promptMtgAppSave: state => {
    return state.promptMtgAppSave;
  },

  showSideBar: state => {
    return state.showSideBar
  },
  editableApplicationApplicant: state => {
    return state.activeApplicationApplicant
  },
  //Data Loading Status
  activeApplicationApplicantLoading: state => {
    return state.activeApplicationApplicantLoading
  },
  allApplicationApplicantsLoading: state => {
    return state.allApplicationApplicantsLoading
  },
  uploadedFileURL: state => {
    return state.uploadedFileURL
  },
  personProfileLoading: state => {
    return state.personProfileLoading
  },
/*  profilePicturePath: state => {
    return state.appUser.profilePicturePath
  },
  profilePicturePathIcon: state => {
    return state.profilePicturePathIcon
  },*/
  lenderResponses: state => {
    return state.lenderResponses
  },
  lenderSubmissions: state => {
    return state.lenderSubmissions
  },
  lenderSubmitResponses: state => {
    return state.lenderSubmitResponses
  },
  getPagination: state => {
    return state.pagination
  },
  getProspectorClientsData: state => {
    return state.prospectorClientsData
  },
  getSelectedProject: state => {
    return state.selectedProject
  },
  getProjectUploadDataLoading: state => {
    return state.projectUploadDataLoading;
  },
  getProjectPerformance: state => {
    return state.projectPerformance;
  },
  getShowApplicant: state => {
    return state.showApplicant;
  },
  sendMarketingEmail: state => {
    return state.sendMarketingEmail;
  },
  getApplicantsCount: state => {
    return state.applicantsCount;
  },
  getNewApplicants: state => {
    return state.newApplicants;
  },
  findApplicants: state => {
    return state.findApplicants;
  },
  loanApplicationNewApplicants: state => {
    return state.loanApplicationNewApplicants;
  },
  bureauRequestedRetrieved: state => {
    return state.bureauRequestedRetrieved
  },

  mortgageApplicationRefresh: state => {
    return state.mortgageApplicationRefresh
  },

  creditBureauMatchIndicator: state => {
    return state.creditBureauMatchIndicator
  },
  appApplicantHistory: state => {
    return state.appApplicantHistory
  },
  appApplicantConsentStatus: state => {
    return state.appApplicantConsentStatus
  },
  ociAppMessage: state => {
    return state.ociAppMessage
  },
  pdfFileName: state => {
    return state.pdfFileName
  },
  campaigns: state => {
    return state.campaigns
  },
   isWithinMortgageApp: state => {
    return state.withinMortgageApp;
  },
  projectName: state => {
    return state.projectName;
  },
  suppressGlobalErrorMessage: state => {
    return state.suppressGlobalErrorMessage
  },
  restrictedEmailAddress: state => {
    return state.restrictedEmailAddress;
  },
  getEditedClientsdata: state => {
    return state.editedClientsData;
  },
  saveStatus: state => {
    return state.saveStatus;
  },
  getApplicationHistory: state => {
    return state.applicationHistory;
  },
  purchaserConsentUpdated: state => {
    return state.purchaserConsentUpdated;
  },
  marketingClientData: state => {
    return state.marketingClientData;
  },
  providerToken: state => {
    return state.providerToken
  },
  additionalFinancialServiceInterestDetails: state => {
    return state.additionalFinancialServiceInterestDetails;
  },
  appApplicantHistoryByLoanApplication: state => {
    return state.appApplicantHistoryByLoanApplication
  },
  appApplicantHistoryLoading: state => {
    return state.appApplicantHistoryLoading;
  },
  wealthSaverAmount: state => {
    return state.wealthSaverAmount
  },
  profileByUser: state => {
    return state.profileByUser
  },
  sendBrokerEmailNotification: state => {
    return state.sendBrokerEmailNotification
  },
  applicantConsentLoading: state => {
    return state.applicantConsentLoading
  },
  applicantSearchLoading: state => {
    return state.applicantSearchLoading
  },
  activeCampaign: state => {
  return state.activeCampaign
  },
  campaignsByProject: state => {
  return state.campaignsByProject
  },
  campaignsByFirm: state => {
  return state.campaignsByFirm
  },
  lendingCriteriaFilters: state => {
    return state.lendingCriteriaFilters
  },
  conditionSet: state => {
    return state.conditionSet
  },
  conditions: state => {
    return state.conditions
  },
  activeCondition: state => {
  return state.activeCondition
  },
  wealthSaverAmtByAppAppId: state => {
  return state.wealthSaverAmtByAppAppId
  },
  borrowersDisclosureFormData: state => {
    return state.borrowersDisclosureFormData
  },
  creditorInsuranceRequests: state => {
    return state.creditorInsuranceRequests
  },
  projectNames: state => {
    return state.projectNames
  },
  brokerProjects: state => {
    return state.brokerProjects
  },
  conditionsLoading: state => {
  return state.conditionsLoading
  },
  applicationConditions: state => {
    return state.applicationConditions
  },
  applicationConditionSet: state => {
  return state.applicationConditionSet
  },
  applicationConditionsLoading: state => {
  return state.applicationConditionsLoading
  },
  conditionsByFirmType: state => {
  return state.conditionsByFirmType
  },
  sendPurchaserConditions: state => {
    return state.sendPurchaserConditions
  },
  documentStatus: state => {
  return state.documentStatus
  },
  profilePicture: state => {
    return state.profilePicture
  },
  campaignsLoading: state => {
  return state.campaignsLoading
  },
  /**
   * Provides a function that retrieves the addresses array of an applicant specified by an index number.
   * Index number pertains to the allApplicationApplicants array in the Vuex state.
   *
   * @param state - Vuex state (automatic argument)
   * @returns {Function} - This inner function directly returns the desired addresses
   */
  applicantAddresses: (state) => (applicantIndex) => {
    try{
      return state.allApplicationApplicants[applicantIndex].applicant.personProfile.addresses;
    }catch(error){
      ociLog("Error in getting applicant address: ", error);
      return null;
    }
  },
  projectsByProfile: state => {
    return state.projectsByProfile
  },
  applicationStatusByAppApplicant: state => {
    return state.applicationStatusByAppApplicant
  },
  purchaserApplicationConditions: state => {
    return state.purchaserApplicationConditions
  },
  loanApplicationsByProject: state => {
    return state.loanApplicationsByProject
  },

  invoiceFormData: state => {
    return state.invoiceFormData
  },
  invoiceList: state => {
    return state.invoiceList
  },
  generatedInvoices: state => {
    return state.generatedInvoices
  },
  invoicing: state => {
    return state.invoicing
  },
  firmRepEmail: state => {
    return state.firmRepEmail
  },

  purchaserActivity: state => {
    return state.purchaserActivity
  },
  purchaserFlow: state => {
    return state.purchaserFlow
  },
  purchaserFlows: state => {
    return state.purchaserFlows
  },
  purchaserData: state => {
    return state.purchaserData
  },

}
